const TransactionType = {
  // deduct balance
  ORDER: 'order',  // user - new order initiate
  TIPS: 'tips',   // user - tips to driver
  PENALTY: 'penalty', // user - payment to penalty due to violate rule
  WITHDRAW: 'withdraw', // user - new withdrawal
  TRANSFER: 'transfer',  // user - new transfer initiate
  DEBIT_TO_CREDIT_TRANSFER: 'debit to credit transfer', // user - new inter transfer initiate (applicable to transfer between own wallet only) 
  DRIVER_PAYMENT: 'driver payment', // admin - pay to driver due to order completed
  REFUND_PAYMENT: 'refund payment', // admin - refund the payment to user
  WITHDRAW_SETTLE: 'withdraw settle', // admin - deduct amount from wallet because cash out to user

  // add balance
  RELOAD: 'reload', // user - new reload balance
  REFUND: 'refund', // user - received refund payment
  RECEIVED: 'received', // user - receive balance from transfer (TRANSFER or INTER_TRANSFER)
  MANUAL_TOP_UP: 'manual top up', // user - manual top up
  TIPS_RECEIVED: 'tips received',   // driver - tips to driver
  EARNING: 'earning', // driver - completed the order
  ORDER_PAYMENT: 'order payment', // admin - received order payment from user
  PENALTY_PAYMENT: 'penalty payment', // admin - received penalty payment from user
  WITHDRAW_PAYMENT: 'withdraw payment', // admin - received withdraw payment from user (hold the amount and proceed to settle the withdrawal)
}

export default TransactionType;
